import { useEffect } from "react";
import Footer from "../components/footer"
import { useState } from "react";

import { auth } from "../lib/firebase";

import logo from "../assets/24logo.png"
import appstore from "../assets/appstore.png"

import TextField from "../components/textfield";
import Button from "../components/button";
import { confirmPasswordReset } from "firebase/auth"
import Header from "../components/header";

import { useNavigate } from "react-router-dom";

export default function ResetPassword() {

    const queryParameters = new URLSearchParams(window.location.search);
    const code = queryParameters.get("oobCode");

    const [password, setPassword] = useState("");
    const [success, setSuccess] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!code) {
            navigate("/");
        }
        document.title = 'Reset Password - SpotUp';
      }, []);

      async function handleReset() {

        confirmPasswordReset(auth, code, password)
            .then(function() {
                setSuccess(true);
            })
            .catch(function() {
                console.log("error");
            })
            
    }

    return (
        <div>
            <Header />
            <div className="section">
                <div className="container password-reset-container">
                    {success ? <p>Password reset successful.</p> :
                        <div className="password-reset-form">
                            <TextField title="New Password" text={password} setText={setPassword} secure={true} />
                            <Button text={"Reset password"} height={52} width={"100%"} offset={5} borderRadius={8} color={"rgba(239, 49, 72, 1)"} secondaryColor={true ? "rgba(74,80,91,1)" : "rgba(176, 34, 51, 1)"} onClick={handleReset} />
                        </div>
                    }
                </div>
            </div>
            <Footer />
        </div>
    )
}